import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import rough from 'roughjs';

const HandDrawnArrows = () => {
    const svgRef = useRef();
    
    // Controls arrow dimensions
    const ARROW_SPREAD = 130;  // How far apart the arrows are horizontally
    const ARROW_LENGTH = 6;   // Controls how far out the C-curves swing horizontally
    const VERTICAL_HEIGHT = 30; // Fixed vertical height
    const CURVE_INTENSITY = 0.2; // Controls curve roundness (0-1, higher = more curved)
    const SVG_WIDTH = Math.max(400, ARROW_SPREAD * 3);
    const SVG_HEIGHT = VERTICAL_HEIGHT + 15;

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        const rc = rough.svg(svg.node());

        // Clear any existing content
        svg.selectAll("*").remove();

        // Use ARROW_SPREAD to position the curves horizontally
        const leftStart = SVG_WIDTH/2 - ARROW_SPREAD;
        const rightStart = SVG_WIDTH/2 + ARROW_SPREAD;
        const leftEnd = SVG_WIDTH/2 - ARROW_SPREAD/1.2;
        const rightEnd = SVG_WIDTH/2 + ARROW_SPREAD/1.2;

        // Calculate control points using CURVE_INTENSITY
        const curveOffset = VERTICAL_HEIGHT * CURVE_INTENSITY;
        const midHeight = VERTICAL_HEIGHT/2;

        // Create C-shaped curved paths with adjustable curve intensity
        const leftArrowPath = `M ${leftStart},0 
            C ${leftStart-ARROW_LENGTH},${curveOffset} 
              ${leftStart-ARROW_LENGTH},${VERTICAL_HEIGHT-curveOffset} 
              ${leftEnd},${VERTICAL_HEIGHT}`;

        const rightArrowPath = `M ${rightStart},0 
            C ${rightStart+ARROW_LENGTH},${curveOffset} 
              ${rightStart+ARROW_LENGTH},${VERTICAL_HEIGHT-curveOffset} 
              ${rightEnd},${VERTICAL_HEIGHT}`;

        // Draw the arrows with a sketchy effect
        const leftArrow = rc.path(leftArrowPath, {
            stroke: 'white',
            strokeWidth: 1.5,
            roughness: 0.5,
            bowing: 1.2
        });

        const rightArrow = rc.path(rightArrowPath, {
            stroke: 'white',
            strokeWidth: 1.5,
            roughness: 0.5,
            bowing: 1.2
        });

        // Adjust arrowhead positions based on endpoints - updated angles to match curve direction
        const leftArrowHead = rc.path(`M ${leftEnd},${VERTICAL_HEIGHT} L ${leftEnd-8},${VERTICAL_HEIGHT-7} L ${leftEnd-3},${VERTICAL_HEIGHT+3} Z`, {
            stroke: 'white',
            fill: 'white',
            fillStyle: 'solid',
            roughness: 0.8
        });

        const rightArrowHead = rc.path(`M ${rightEnd},${VERTICAL_HEIGHT} L ${rightEnd+8},${VERTICAL_HEIGHT-7} L ${rightEnd+3},${VERTICAL_HEIGHT+3} Z`, {
            stroke: 'white',
            fill: 'white',
            fillStyle: 'solid',
            roughness: 0.8
        });

        svg.node().appendChild(leftArrow);
        svg.node().appendChild(rightArrow);
        svg.node().appendChild(leftArrowHead);
        svg.node().appendChild(rightArrowHead);
    }, []);

    return (
        <svg
            ref={svgRef}
            width={SVG_WIDTH} 
            height={SVG_HEIGHT}
            viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
            style={{ 
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                top: 115,
                pointerEvents: 'none'
            }}
        />
    );
};

export default HandDrawnArrows;